/* eslint-disable */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import { IUser } from 'src/interfaces';
import CompanyService from 'src/services/company.services';

export const useUpdateuser = (): UseMutationResult<any, Error, { updateUser: any }, void> =>
  useMutation(({ updateUser }: { updateUser: any }) => CompanyService.updateUser(updateUser), {
    onSuccess: () => {
      AlertAdapter('User updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateuserSupport = (): UseMutationResult<any, Error, { updateUser: any }, void> =>
  useMutation(({ updateUser }: { updateUser: any }) => CompanyService.updateUserSupport(updateUser), {
    onSuccess: () => {
      AlertAdapter('User updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const usePromoteuser = (): UseMutationResult<any, Error, { promoteUser: any }, void> =>
  useMutation(({ promoteUser }: { promoteUser: any }) => CompanyService.promoteUser(promoteUser), {
    onSuccess: () => {
      AlertAdapter('User updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const usePromoteuserSupport = (): UseMutationResult<any, Error, { promoteUserSupport: any }, void> =>
  useMutation(
    ({ promoteUserSupport }: { promoteUserSupport: any }) => CompanyService.promoteUserSupport(promoteUserSupport),
    {
      onSuccess: () => {
        AlertAdapter('User updated Successfully', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const updateSupportModule = (): UseMutationResult<any, Error, { payload: any }, void> =>
  useMutation(({ payload }: { payload: any }) => CompanyService.updateModuleEmail(payload), {
    onSuccess: () => {
      AlertAdapter('User updated Successfully', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
